<template>
  <div class="status-legend">
    <span class="status" v-for="(status, index) in statusOptions" :key="index">
      <BadgeCircle :color="status.color" />
      {{ status.legend }}
    </span>
  </div>
</template>

<script>
import BadgeCircle from './BadgeCircle';

export default {
  name: 'StatusLegend',
  components: {
    BadgeCircle,
  },
  props: {
    statusOptions: {
      type: Array,
      required: true,
    }
  }
}
</script>

<style lang="scss" scoped>
.status-legend {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.625rem;

  .status {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    font-size: 0.625rem;
    font-weight: 600;
    color: #202224;
  }
}
</style>